export const POTD_CODE_LENGTH = 6;

const MS_PER_DAY = 86_400_000;

export function buildPotdMaterial(date: string): string {
  return `1nl-potd|${date}`;
}

export function potdCodeFromHmac(hmac: Uint8Array): string {
  const n = hmac[0]! * 0x1000000 + hmac[1]! * 0x10000 + hmac[2]! * 0x100 + hmac[3]!;
  return String(n % 1000000).padStart(POTD_CODE_LENGTH, '0');
}

export function potdUtcToday(nowIso: string): string {
  return new Date(Date.parse(nowIso)).toISOString().slice(0, 10);
}

export function potdCandidateDates(nowIso: string): [string, string, string] {
  const nowMs = Date.parse(nowIso);
  return [-MS_PER_DAY, 0, MS_PER_DAY].map((offset) => new Date(nowMs + offset).toISOString().slice(0, 10)) as [string, string, string];
}

export function formatPotdCode(code: string): string {
  return `${code.slice(0, 3)}-${code.slice(3)}`;
}
